import { render } from "./PayerForm.vue?vue&type=template&id=25743ff2&ts=true"
import script from "./PayerForm.ts?vue&type=script&lang=ts&external"
export * from "./PayerForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__